import {map as actions} from '../../../data/booking/constants/action_types';
import {searchStops, planStepsForHike, getThemes, getSteps} from "../../../data/booking/api/api";
import {kml} from "@tmcw/togeojson";
import {isEmpty} from "lodash";
import {normalize} from "normalizr";
import {arrayOfSteps, arrayOfThemes} from "../../../data/booking/api/schema";

const showStops = () => ({
    type: actions.DISPLAY_STOPS,
    display: true
})

const hideStops = () => ({
    type: actions.DISPLAY_STOPS,
    display: true
})

const requestStops = () => ({
    type: actions.REQUEST_STOPS
})

const receiveStops = (stops) => ({
    type: actions.RECEIVE_STOPS,
    stops
})

const requestPlanSteps = () => ({
    type: actions.REQUEST_PLAN_STEPS
})

const receivePlanSteps = (steps) => ({
    type: actions.RECEIVE_PLAN_STEPS,
    steps
})

const moseOverStop = (stopId) => ({
    type: actions.MOSE_HOVER_STOP,
    stopId
})

const selectDeparture = (step, stop) => ({
    type: actions.SELECT_DEPARTURE_STEP,
    step,
    stop
})

const selectArrival = (step, stop) => ({
    type: actions.SELECT_ARRIVAL_STEP,
    step,
    stop
})

const selectTheme = (theme) => (dispatch, getState) => {
    const {entities, kmlData} = getState().booking.map
    if(theme) {
        theme.hikes.forEach(hikeId => {
            const hike = entities.hikes[hikeId]
            if (hike.kmlPath && isEmpty(kmlData[hike.id])) {
                loadKml(hike.kmlPath)
                    .then(parsedGeojson => dispatch(setKmlData(hike.id, parsedGeojson)))
            }
        })
    }
    return dispatch({
        type: actions.SELECT_THEME,
        theme
    })
}

const setKmlData = (hikeId, data) => ({
    type: actions.SET_KML_DATA,
    data,
    hikeId
})

const updateFilters = (filter) => ({
    type: actions.UPDATE_FILTERS,
    filter
})

const editStep = (stepIndex) => ({
    type: actions.EDIT_STEP,
    stepIndex
})

const addStep = (serviceId) => ({
    type: actions.ADD_STEP,
    serviceId
})

const saveStep = (stepIndex) => ({
    type: actions.SAVE_STEP,
    stepIndex
})

const deleteStep = (stepIndex) => ({
    type: actions.DELETE_STEP,
    stepIndex
})

const newStep = () => ({
    type: actions.NEW_STEP
})

const saveStop = (stop) => ({
    type: actions.SAVE_STOP,
    stop
})

const selectStep = (step) => ({
    type: actions.SELECT_STEP,
    step
})

const selectStop = (step, stop) => ({
    type: actions.SELECT_STOP,
    step,
    stop
})

const cancelTripEdit = () => ({
    type: actions.CANCEL_TRIP_EDIT
})

const toggleSummary = () => ({
    type: actions.TOGGLE_SUMMARY,
})

const moveHikerMarker = (coordinates) => ({
    type: actions.MOVE_HIKER_MARKER,
    coordinates
})

const updateMapLayer = (mapLayer) => ({
    type: actions.CHANGE_MAP_LAYER,
    mapLayer
})

const fetchStops = (_northEast, _southWest) => (dispatch, getState) =>{
    const map = getState().booking.map;
    const departureStep = map.trip.selectedStep
    const hike = map.trip.hike
    const showStops = map.showStops
    if(hike && departureStep && showStops) {
        dispatch(requestStops())
        searchStops(_southWest.lat, _southWest.lng, _northEast.lat, _northEast.lng, hike.id ?? hike)
            .then(result => result.json())
            .then(json => {
                dispatch(receiveStops(json))
            })
    }
}

const planSteps = (distance) => (dispatch, getState) =>{
    dispatch(requestPlanSteps())
    planStepsForHike(getState().booking.map.trip.hike.id, distance)
        .then(result => result.json())
        .then(json => {
            dispatch(receivePlanSteps(json))
        })
}

const selectHike = (hike, theme = null) => (dispatch, getState) => {

    dispatch({
        type: actions.SELECT_HIKE,
        hike,
        theme
    })

    return dispatch(loadHike(hike))
}

const loadHike = (hike) => (dispatch, getState) => {
    const {hikes} = getState().booking.map.entities
    const kmlData = getState().booking.map.kmlData;

    if(hike && (isEmpty(hikes[hike.id]) || isEmpty(hikes[hike.id].steps))) {
        dispatch({
            type: actions.REQUEST_HIKE_STEPS,
            hikeId: hike.id
        })
        getSteps(hike.id)
            .then(result => result.json())
            .then(json => normalize(json, arrayOfSteps))
            .then(steps => {
                dispatch({
                    type: actions.RECEIVE_HIKE_STEPS,
                    hikeId: hike.id,
                    steps
                })
            })
    }

    if(hike){
        if(hike.kmlPath && isEmpty(kmlData[hike.id])) {
            loadKml(hike.kmlPath)
                .then(parsedGeojson => dispatch(setKmlData(hike.id, parsedGeojson)))
        }
        if(hike.variants.length > 0){
            hike.variants.forEach(variant => {
                if(!isEmpty(hikes[variant.hikeId]) && hikes[variant.hikeId].kmlPath && isEmpty(kmlData[variant.hikeId])){
                    loadKml(hikes[variant.hikeId].kmlPath)
                        .then(parsedGeojson => dispatch(setKmlData(variant.hikeId, parsedGeojson)))
                }
            })
        }
    }

}


const startTripEdit = () => (dispatch, getState)  => {
    return dispatch({
        type: actions.START_TRIP_EDIT
    })
}

const getHikeThemes = () => (dispatch, getState) => {

    dispatch({
        type: actions.REQUEST_THEMES,
    })

    return getThemes()
        .then(result => result.json())
        .then(json => normalize(json, arrayOfThemes))
        .then(themes => dispatch({
                type: actions.RECEIVE_THEMES,
                themes
            })
        )
}

const moseOverHike = (hike) => (dispatch, getState) => {

    dispatch({
        type: actions.MOSE_OVER_HIKE,
        hike
    })

    if(hike && hike.kmlPath && isEmpty(getState().booking.map.kmlData[hike.id])) {
        loadKml(hike.kmlPath)
            .then(parsedGeojson => dispatch(setKmlData(hike.id, parsedGeojson)))
    }
}

const loadKml = (kmlUrl) =>{
    return fetch('/'+kmlUrl)
        .then(response => response.text())
        .then(xml => {
            const parser = new DOMParser();
            const data = parser.parseFromString(xml, 'text/xml');

            let geoJSON = kml(data);

            let parsedGeojson = {};
            geoJSON.features.forEach((feature) => {
                if (!isEmpty(feature.geometry)) {
                    if (!parsedGeojson[feature.geometry.type]) {
                        parsedGeojson[feature.geometry.type] = feature.geometry.type == 'LineString' ? [] : {};
                    }

                    if (feature.geometry.type == 'LineString') {
                        feature.bounds = L.geoJSON(feature).getBounds();
                        parsedGeojson[feature.geometry.type].push(feature);
                    } else if (feature.geometry.type == 'Point') {
                        if (!parsedGeojson[feature.geometry.type][feature.properties.type]) {
                            parsedGeojson[feature.geometry.type][feature.properties.type] = [];
                        }
                        parsedGeojson[feature.geometry.type][feature.properties.type].push(feature);
                    }
                }
            })
            console.log("recuperation kml")
            return parsedGeojson
        })
}

const updateBounds = (corner1 = null, corner2 = null) => {

    return {
        type: actions.UPDATE_BOUNDS,
        corner1,
        corner2
    }
}

const refreshBounds = () => (dispatch, getState) => {
    return {
        type: actions.REFRESH_BOUNDS
    }
}

const selectHikeBySlug = (hike) => ({
    type: actions.PRESELECT_HIKE,
    hike
})

const setDirection = (direction) => ({
    type: actions.SET_DIRECTION,
    direction
})

const addServiceFromSession = (service) => ({
    type: actions.ADD_SERVICE_FROM_SESSION,
    service
})

export {
    requestStops,
    receiveStops,
    moseOverStop,
    selectDeparture,
    selectArrival,
    selectTheme,
    selectHike,
    moseOverHike,
    updateFilters,
    setKmlData,
    loadKml,
    editStep,
    saveStep,
    newStep,
    addStep,
    saveStop,
    fetchStops,
    selectStep,
    selectStop,
    toggleSummary,
    moveHikerMarker,
    planSteps,
    deleteStep,
    startTripEdit,
    cancelTripEdit,
    updateMapLayer,
    updateBounds,
    refreshBounds,
    getHikeThemes,
    showStops,
    hideStops,
    loadHike,
    selectHikeBySlug,
    setDirection,
    addServiceFromSession
}